import React from 'react';
import { UserRoundIcon } from 'lucide-react';
import { BrandLogo } from './BrandLogo';
import { NavTabs, type ViewTab } from './NavTabs';
interface AppHeaderProps {
  tab: ViewTab;
  onTabChange: (tab: ViewTab) => void;
  controls?: React.ReactNode;
}
export function AppHeader({
  tab,
  onTabChange,
  controls
}: AppHeaderProps) {
  return <header className="sticky top-0 z-30 border-b border-line bg-surface/90 backdrop-blur-md" data-id="element-366" data-mp="3hcf3jrctwbp6">
      <div className="mx-auto flex max-w-[1440px] flex-wrap items-center gap-x-10 gap-y-3 px-4 py-3 sm:px-6 lg:px-10" data-id="element-367" data-mp="8wvaotg2kvan">
        <BrandLogo data-id="element-368" data-mp="dx9axpbfj0y4" />
        <nav className="order-3 -mx-1 w-full overflow-x-auto px-1 lg:order-none lg:w-auto" data-id="element-369" data-mp="3vc7ot75l5zpr">
          <NavTabs value={tab} onChange={onTabChange} data-id="element-370" data-mp="45n2u1ue1hzl" />
        </nav>
        <div className="ml-auto flex items-center gap-2" data-id="element-371" data-mp="43sjgryrlxxm">
          {controls}
          <span className="ml-1 flex h-9 w-9 items-center justify-center rounded-full bg-accent-soft text-accent" role="img" aria-label="Your account" data-id="element-372" data-mp="rufsxhobwvma">
            <UserRoundIcon className="h-4 w-4" aria-hidden data-id="element-373" data-mp="3cshk3b4ku5vq" />
          </span>
        </div>
      </div>
    </header>;
}